import * as actions from './constants';

export const defaultState = {
    loading: false,
    saved: false,
    profile: null, 
    error: null
}

export default function reducer(state=defaultState, action) {
    const { type, payload=null, error=null } = action;

    switch (type) {

        case actions.UPDATTE_PROFILE_ITEM_RESET: {
            return {
                ...defaultState
            }
        }

        case actions.UPDATTE_PROFILE_ITEM_START: {
            return {
                ...defaultState,
                loading: true
            }
        }


        case actions.UPDATTE_PROFILE_ITEM_SUCCESS: {
            return {
                ...defaultState,
                saved: true,
                profile: payload
            }
        }

        case actions.UPDATTE_PROFILE_ITEM_FAILURE: {
            return {
                ...defaultState,
                error
            }
        }        

        default: {
            return state;
        }
    }
}